import { useRef, useState } from "react";
import { alpha } from "@mui/material/styles";
import { Button, Box, Divider, Typography, IconButton } from "@mui/material";
import MenuPopover from "../../components/MenuPopover";
import { getUser, logout } from "../../services/authService";
import ResetPasswordDialog from "../../components/ResetPasswordDialog";
import { Settings } from "@mui/icons-material";

export default function AccountPopover() {
  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [openReset, setOpenReset] = useState(false);

  const user = getUser();

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const logOutAndMoveOn = () => {
    logout();
    window.location = "/";
  };

  const resetPassword = () => {
    setOpenReset(true);
  };

  const handleResetClose = () => {
    setOpenReset(false);
  };

  return (
    <>
      <ResetPasswordDialog
        open={openReset}
        handleClose={handleResetClose}
        setOpen={setOpenReset}
      />
      <IconButton
        ref={anchorRef}
        id="accout-menu"
        onClick={handleOpen}
        sx={{
          padding: 0,
          height: "30px",
          width: "30px",
          backgroundColor: "#e7e7e7",
          ...(open && {
            "&:before": {
              zIndex: 1,
              content: "''",
              width: "100%",
              height: "100%",
              borderRadius: "50%",
              position: "absolute",
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.72),
            },
          }),
        }}
      >
        <Settings fontSize="small" />
      </IconButton>

      <MenuPopover
        open={open}
        onClose={handleClose}
        anchorEl={anchorRef.current}
        sx={{ width: 180 }}
      >
        <Box sx={{ my: 1, px: 2 }}>
          <Typography variant="subtitle1" fontSize="13px" noWrap>
            {user?.getUserFullName()}
          </Typography>
          <Typography
            variant="body2"
            sx={{ color: "text.secondary" }}
            fontSize="12px"
            noWrap
          >
            {user?.designation}
          </Typography>
        </Box>

        <Divider sx={{ my: 1 }} />

        <Box sx={{ p: 1.5, pt: 1 }}>
          <Button
            fullWidth
            color="inherit"
            id="logout-btn"
            variant="outlined"
            sx={{ mb: 1, fontSize: "12px" }}
            onClick={resetPassword}
          >
            Reset Password
          </Button>
          <Button
            fullWidth
            color="inherit"
            id="logout-btn"
            variant="outlined"
            sx={{ fontSize: "12px" }}
            onClick={logOutAndMoveOn}
          >
            Logout
          </Button>
        </Box>
      </MenuPopover>
    </>
  );
}
